import { Base, getClosestParent } from "@studiometa/js-toolkit";
import { EVENTS } from "./utils.js";
import { FrameTriggerLoader } from "./FrameTriggerLoader.js";
class AbstractFrameTrigger extends Base {
  /**
   * Config.
   */
  static config = {
    name: "AbstractFrameTrigger",
    emits: Object.values(EVENTS),
    options: {
      requestInit: Object,
      headers: Object
    },
    components: {
      FrameTriggerLoader
    }
  };
  /**
   * The URL to use for the request.
   */
  get url() {
    return new URL(this.$el instanceof HTMLFormElement ? this.$el.action : this.$el.href);
  }
  /**
   * Option for the fetch request.
   */
  get requestInit() {
    const { requestInit, headers } = this.$options;
    return {
      ...requestInit,
      // @ts-expect-error this will be right.
      trigger: this,
      headers: {
        ...requestInit.headers,
        ...headers
      }
    };
  }
  /**
   * Trigger FrameLoaders enter.
   */
  onFrameFetchBefore() {
    if (this.$children.FrameTriggerLoader) {
      for (const loader of this.$children.FrameTriggerLoader) {
        if (getClosestParent(loader, this.constructor) === this) {
          loader.enter();
        }
      }
    }
  }
  /**
   * Trigger FrameLoaders leave.
   */
  onFrameFetchAfter() {
    if (this.$children.FrameTriggerLoader) {
      for (const loader of this.$children.FrameTriggerLoader) {
        if (getClosestParent(loader, this.constructor) === this) {
          loader.leave();
        }
      }
    }
  }
  /**
   * Trigger request.
   */
  async trigger() {
    const { url, requestInit } = this;
    this.$log("trigger", url, requestInit);
    this.$emit(EVENTS.TRIGGER, url, requestInit);
  }
}
export {
  AbstractFrameTrigger
};
//# sourceMappingURL=AbstractFrameTrigger.js.map
